// extracted by mini-css-extract-plugin
module.exports = {"title-container":"SheetName_title-container__2c4-A","title":"SheetName_title__2aFwJ"};